// https://css-tricks.com/clearfix-a-lesson-in-web-development-evolution/
export var clearFixMixin = function clearFixMixin() {
  return "\n    &:before,\n    &:after {\n        content: ' ';\n        display: table;\n    }\n    &:after {\n        clear: both;\n    }\n";
};